import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class VppService {
  async getAllAccountVpp(params, accountId) {
    try {
      const { page, size, sortBy, sort_order } = params
      let url = Urls.getApiUrl(`admin/${accountId}/vpp/all`, MICROSERVICES.VPPMANAGER)
      url = `${url}?page_no=${page}&page_size=${size}&sort_by=${sortBy || ''}&sort_order=${sort_order || ''}`
      const response = await service.get(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllProgramVppView(params, accountId) {
    try {
      const { page, size, sortBy, programId, sort_order } = params
      let url = Urls.getApiUrl(`admin/${accountId}/vpp/all`, MICROSERVICES.VPPMANAGER)
      url = `${url}?page_no=${page}&page_size=${size}&sort_by=${sortBy || ''}&program_id=${programId || ''}&sort_order=${sort_order || ''}`
      const response = await service.get(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getVppDetails(vppId, accountId) {
    try {
      let url = Urls.getApiUrl(`admin/${accountId}/vpp/${vppId}`, MICROSERVICES.VPPMANAGER)
      const response = await service.get(url)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async createVpp(params, accountId) {
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${accountId}/vpp/add`, MICROSERVICES.VPPMANAGER), params)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async updateVpp(vppId, params, accountId) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${accountId}/vpp/${vppId}`, MICROSERVICES.VPPMANAGER), params)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async putVppQuery(programId, params, accountId) {
    try {
      const response = await service.put(Urls.getApiUrl(`admin/${accountId}/vpp/query/program/${programId}`, MICROSERVICES.VPPMANAGER), params)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async deleteVpp(vppId, accountId) {
    try {
      const response = await service.delete(Urls.getApiUrl(`admin/${accountId}/vpp/${vppId}`, MICROSERVICES.VPPMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllProgramVpp(accountId, programId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/vpp/${programId}/all`, MICROSERVICES.VPPMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllForcastData(site_ids, duration, granularity) {
    const params = { site_ids, duration, granularity }
    try {
      const response = await service.post(Urls.getApiUrl(`admin/*/forecast`, MICROSERVICES.TELEMETRYMANAGER), params)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const vppService = new VppService()
